var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDhl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 161,
    viewBox: "0 0 165 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_245_68580)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 165,
    height: 161,
    rx: 80.5,
    fill: "#DFB50B"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_245_68580)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 88.1504H34.778L33.9 89.4104H19.5V88.1504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.5 89.4104H126.798L127.764 88.1504H145.588V89.4104H145.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 85.8101H36.5341L35.5683 87.0701H19.5V85.8101Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 83.4702H38.2902L37.3244 84.7302H19.5V83.4702Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.5 87.0701H128.554L129.52 85.8101H145.588V87.0701H145.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.188 83.4702H145.5V84.7302H130.222L131.188 83.4702Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0068 89.4103L44.0849 78.3403C44.0849 78.3403 53.041 78.3403 54.0946 78.3403C55.2361 78.3403 55.2361 78.7903 54.6215 79.5103C54.0946 80.2303 53.1288 81.5803 52.602 82.3003C52.3385 82.7503 51.8117 83.3803 53.48 83.3803C55.3239 83.3803 66.9142 83.3803 66.9142 83.3803C65.8605 85.0003 62.1727 89.5003 55.6751 89.5003C50.4068 89.4103 36.0068 89.4103 36.0068 89.4103Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2804 83.4702L77.8901 89.5002H66.3877L70.7779 83.4702H82.2804Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0508 83.4702L94.6606 89.5002H83.0703L87.4606 83.4702H99.0508Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.827 83.4702C102.827 83.4702 101.949 84.6402 101.597 85.1802C100.105 87.1602 101.422 89.5002 106.163 89.5002C111.607 89.5002 124.778 89.5002 124.778 89.5002L129.168 83.4702H102.827Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7148 71.5002L37.6758 76.9902C37.6758 76.9902 58.4855 76.9902 59.627 76.9902C60.7685 76.9902 60.7685 77.4402 60.1538 78.1602C59.627 78.8802 58.6611 80.2302 58.1343 80.9502C57.8709 81.3102 57.3441 82.0302 59.0124 82.0302C60.8563 82.0302 67.9685 82.0302 67.9685 82.0302C67.9685 82.0302 69.4611 80.0502 70.6026 78.3402C72.2709 76.0902 70.7782 71.4102 64.8953 71.4102C59.627 71.5002 41.7148 71.5002 41.7148 71.5002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.017 82.03H71.7441L79.471 71.5H91.0612L86.671 77.53H91.8515L96.2417 71.5H107.832L100.017 82.03Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.812 71.5L116.086 82.03H103.793L111.52 71.5H123.812Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_245_68580",
    x: -60,
    y: -60,
    width: 285,
    height: 281,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 30
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_245_68580"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_245_68580",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_245_68580"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 126,
    height: 18,
    fill: "white",
    transform: "translate(19.5 71.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDhl);
export default __webpack_public_path__ + "static/media/DHL.e96ade2d97b3650d19c80578f3bbb2ed.svg";
export { ForwardRef as ReactComponent };